import PropTypes from "prop-types";
import React from "react";
import videojs from "video.js";
import "videojs-seek-buttons";
import LoopButton from "./LoopButton";

export default class VideoPlayer extends React.Component {
    componentDidMount() {
        this.player = videojs(this.videoNode, this.props);
        const {
            seekSize,
            loop,
        } = this.props;

        if (seekSize) {
            this.player.seekButtons({
                forward: seekSize,
                back: seekSize
            });
        }

        if (loop) {
            const loopButton = new LoopButton(this.player);
            this.player.controlBar.addChild(loopButton);
        }
    }

    componentWillUnmount() {
        if (this.player) {
            this.player.dispose();
        }
    }

    render() {
        const {
            sources
        } = this.props;

        return (
            <div className="vjs-container">
                <div data-vjs-player>
                    <video
                      src={sources ? sources[0].src : undefined}
                      ref={node => this.videoNode = node}
                      className="video-js">
                    </video>
                </div>
            </div>
        );
    }
}

VideoPlayer.propTypes = {
    sources: PropTypes.array.isRequired,

    loop: PropTypes.bool,
    seekSize: PropTypes.number,
};



// WEBPACK FOOTER //
// ./app/lib/common/components/VideoPlayer.js